import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BuilderBranchCondition } from '../../../../classes/questionnaire-builder/builder-branch-condition';
import { BuilderQuestion } from '../../../../classes/questionnaire-builder/builder-question';
import { BuilderBranchConditionComponent } from '../../../../classes/questionnaire-builder/builder-branch-condition-component';
import { BranchConditionOperand } from '../../../../enums/branch-condition-operand';
import { BranchConditionOperator } from '../../../../enums/branch-condition-operator';
import { QuestionType } from '../../../../api/models';

@Component({
  selector: 'app-edit-branch-condition',
  templateUrl: './edit-branch-condition.component.html',
  standalone: false,
})
export class EditBranchConditionComponent {
  @Input({ required: true }) branchCondition!: BuilderBranchCondition;
  @Input({ required: true }) availableBranchQuestions!: BuilderQuestion[];
  @Input({ required: true }) question!: BuilderQuestion;

  @Output() branchConditionDeleted = new EventEmitter<BuilderBranchCondition>();
  protected readonly BranchConditionOperand = BranchConditionOperand;
  protected readonly QuestionType = QuestionType;

  addConditionComponent() {
    this.branchCondition.conditionExpressionComponents.push(
      new BuilderBranchConditionComponent(
        BranchConditionOperand.QuestionAnswer,
        BranchConditionOperator.Contains,
        '',
      ),
    );
  }

  setComparisonValue(component: BuilderBranchConditionComponent) {
    // Need to ensure that comparisonValue is always cast to a string
    component.comparisonValue = component.comparisonValue.toString();
  }

  getAvailableOperators(
    operand: BranchConditionOperand,
  ): BranchConditionOperator[] {
    if (
      operand === BranchConditionOperand.QuestionScore ||
      operand === BranchConditionOperand.QuestionSetScore
    ) {
      return [
        BranchConditionOperator.Equals,
        BranchConditionOperator.DoesNotEqual,
        BranchConditionOperator.GreaterThan,
        BranchConditionOperator.LessThan,
      ];
    } else {
      return [
        BranchConditionOperator.Contains,
        BranchConditionOperator.DoesNotContain,
      ];
    }
  }

  getAvailableOperands(): BranchConditionOperand[] {
    return [
      BranchConditionOperand.QuestionAnswer,
      BranchConditionOperand.QuestionScore,
      BranchConditionOperand.QuestionSetScore,
    ];
  }

  deleteCondition() {
    this.branchConditionDeleted.emit(this.branchCondition);
  }

  deleteComponent(component: BuilderBranchConditionComponent) {
    this.branchCondition.conditionExpressionComponents =
      this.branchCondition.conditionExpressionComponents.filter(
        (c) => c !== component,
      );
  }
}
